{
  "paymentInformation": "Betalningsuppgifter",
  "paymentReferences": "Referenser och kontonummer",
  "paymentHistory": "Betalningshistoria",
  "currentMonth": "Innevarande månad",
  "invoices": "Fakturor",
  "itemisation": "Betalningsspecifikation",
  "payer": "Betalare",
  "dueDate": "Förfallodag",
  "sum": "Belopp",
  "sumTotal": "Totalt",
  "remittances": "Betalningar",
  "refund": "Återbetalning",
  "transfer": "Överföring",
  "withheldFrom": {
    "securityDeposit": "Avdrag från depositionsavgift",
    "depositVoucher": "Avdrag från betalningsförbindelse",
    "rooFee": "Avdrag från bostadsrättsavgift"
  },
  "paidDate": "Betalda",
  "noTargets": "Inga fakturarader",
  "creditNote": "Kredit",
  "noRemittances": "Inga betalningar",
  "arrearTotal": "Totalt belopp som ska betalas",
  "advanceTotal": "Totalt förskott",
  "arrearTotalForMonth": "Att betala {{month}}",
  "advanceTotalForMonth": "Förskott {{month}}",
  "neutralTotal": "Totalt",
  "saldo": "Saldo",
  "paymentTypeCategory": {
    "chargesForUtilities": "Bruksavgift",
    "rent": "Hyra",
    "residenceCharge": "Bruksvederlag",
    "rightOfOccupancyDeposit": "Bostadsrättsavgift",
    "securityDeposit": "Depositionsavgift",
    "interest": "Ränta",
    "generic": "Allmän",
    "rightOfOccupancyNewDevelopmentDeposit": "Bostadsrättsavgift för nybyggnad"
  },
  "paymentsBeneficiary": "Mottagare",
  "referenceNumber": "Fakturornas referensnummer",
  "noAccountData": "Kontouppgifter saknas",
  "rightOfOccupancyFee": {
    "tab": "Bostadsrättsavgift",
    "preliminaryNotice": "Detta är en preliminär kalkyl. Den slutliga bostadsrättsavgiften beräknas när bostadsrätten upphör.",
    "currentValueTitle": "Bostadsrättsavgiftens nuvärde",
    "currentValueIndexInfo": "Kalkylen baserar sig på byggnadskostnadsindexet {{month}}. Värdet uppdateras när byggnadskostnadsindexet eller ombyggnadstilläggen ändras.",
    "originalValue": "Ursprunglig bostadsrättsavgift",
    "indexAdjustment": "Indexhöjning",
    "improvementValue": "Ombyggnadstillägg",
    "currentValue": "Nuvärde",
    "paidTitle": "Betald bostadsrättsavgift",
    "paidAmount": "Betalt belopp",
    "paidDate": "Betalningsdag",
    "notPaidWarning": "Bostadsrättsavgiften har inte betalats ännu",
    "payableTitle": "Bostadsrättsavgift att betala",
    "amountPayable": "Belopp att betala",
    "remainingPayable": "Återstår att betala",
    "goToPaymentReferences": "Gå till betalningsreferenserna",
    "finalCalculationNotice": "Slutkalkylen för bostadsrättsavgiften skickas separat.",
    "valueAtTerminationTitle": "Bostadsrättsavgiften när avtalet upphör",
    "valueAtTerminationIndexInfo": "Kalkylen baserar sig på byggnadskostnadsindexet {{month}}, som gällde när avtalet upphörde.",
    "valueAtTermination": "Värde när avtalet upphör",
    "withholdingsAndRefundsTitle": "Avdrag och återbetalningar",
    "withholding": "Avdrag: {{description}}",
    "refund": "Återbetalning {{date}}",
    "remainingValue": "Återstående värde"
  },
  "errors": {
    "failedToLoadPaymentInfo": "Det gick inte att ladda betalningsuppgifterna",
    "failedToLoadPaymentHistory": "Det gick inte att ladda betalningshistorian",
    "paymentsAccessDenied": "Du har inte tillräckliga behörigheter att se betalningsuppgifterna för detta avtal."
  },
  "bankAccountLabel": "{{category}}, {{bankName}}"
}
